<div class="alert" [ngClass]="type">
  <ion-icon [name]="iconName" class="icon"></ion-icon>
  <div class="message">{{ message }}</div>
</div>
